import { create_dsar_form, create_pi_inventory_form, create_processing_form } from './data_privacy_builders';
import { dsar_rows, pi_inventory_rows, processing_rows } from './data_privacy_rows';

function sync_drawer_scroll(ctx, ref_name) {
  ctx.$nextTick(() => {
    const drawer_body = Reflect.get(ctx.$refs, ref_name);
    if (drawer_body) drawer_body.scrollTop = 0;
  });
}

function has_open_privacy_overlay(ctx) {
  const overlay_flags = [
    ctx.pi_inventory_modal_open,
    Boolean(ctx.active_pi_inventory_ref),
    ctx.processing_modal_open,
    Boolean(ctx.active_processing_ref),
    ctx.dsar_modal_open
  ];
  const has_open_overlay = overlay_flags.some(Boolean);
  return has_open_overlay;
}

export const data_privacy_computed = {
  active_pi_inventory_drawer() {
    if (!this.active_pi_inventory_ref) return null;
    return this.pi_inventory_rows.find((row) => row.ref === this.active_pi_inventory_ref) || null;
  },
  pi_inventory_modal_title() {
    return this.pi_inventory_edit_index === null ? 'New personal information element' : 'Edit personal information element';
  },
  pi_inventory_modal_action_label() {
    return this.pi_inventory_edit_index === null ? 'Create' : 'Save changes';
  },
  active_processing_drawer() {
    if (!this.active_processing_ref) return null;
    return this.processing_rows.find((row) => row.ref === this.active_processing_ref) || null;
  },
  processing_modal_title() {
    return this.processing_edit_index === null ? 'New processing activity' : 'Edit processing activity';
  },
  processing_modal_action_label() {
    return this.processing_edit_index === null ? 'Create' : 'Save changes';
  },
  dsar_modal_title() {
    return this.dsar_edit_index === null ? 'New data subject request' : 'Edit data subject request';
  },
  dsar_modal_action_label() {
    return this.dsar_edit_index === null ? 'Create' : 'Save changes';
  }
};

export const data_privacy_seed_sequences = {
  pi_inventory_sequence: pi_inventory_rows.length,
  processing_sequence: processing_rows.length,
  dsar_sequence: dsar_rows.length + 3
};

export const data_privacy_methods = {
  set_tab(tab_id) {
    this.active_tab = tab_id;
    this.close_pi_inventory_modal();
    this.close_pi_inventory_drawer();
    this.close_processing_modal();
    this.close_processing_drawer();
    this.close_dsar_modal();
  },
  sync_overlay_state() {
    if (typeof document === 'undefined') return;
    const has_open_overlay = has_open_privacy_overlay(this);
    document.body.classList.toggle('privacy-overlay-open', has_open_overlay);
  },
  open_pi_inventory_drawer(row_or_ref) {
    const row_ref = typeof row_or_ref === 'string' ? row_or_ref : row_or_ref?.ref;
    if (!row_ref) return;
    this.pi_inventory_modal_open = false;
    this.active_pi_inventory_ref = row_ref;
    this.sync_overlay_state();
    sync_drawer_scroll(this, 'piInventoryDrawerBody');
  },
  close_pi_inventory_drawer() {
    this.active_pi_inventory_ref = null;
    this.sync_overlay_state();
  },
  open_processing_drawer(row_or_ref) {
    const row_ref = typeof row_or_ref === 'string' ? row_or_ref : row_or_ref?.ref;
    if (!row_ref) return;
    this.processing_modal_open = false;
    this.active_processing_ref = row_ref;
    this.sync_overlay_state();
    sync_drawer_scroll(this, 'processingDrawerBody');
  },
  close_processing_drawer() {
    this.active_processing_ref = null;
    this.sync_overlay_state();
  },
  close_dsar_modal() {
    this.dsar_modal_open = false;
    this.dsar_edit_index = null;
    this.dsar_form = create_dsar_form();
    this.sync_overlay_state();
  },
  delete_dsar_modal() {
    if (this.dsar_edit_index === null) return;
    this.dsar_rows.splice(this.dsar_edit_index, 1);
    this.close_dsar_modal();
  },
  edit_active_pi_inventory_record() {
    if (!this.active_pi_inventory_drawer) return;
    const index = this.pi_inventory_rows.findIndex((row) => row.ref === this.active_pi_inventory_drawer.ref);
    if (index !== -1) this.open_pi_inventory_modal(this.active_pi_inventory_drawer, index);
  },
  edit_active_processing_record() {
    if (!this.active_processing_drawer) return;
    const index = this.processing_rows.findIndex((row) => row.ref === this.active_processing_drawer.ref);
    if (index !== -1) this.open_processing_modal(this.active_processing_drawer, index);
  }
};

export const data_privacy_hooks = {
  mounted() { this.sync_overlay_state(); },
  beforeDestroy() { if (typeof document !== 'undefined') document.body.classList.remove('privacy-overlay-open'); }
};

export const data_privacy_watch = {
  pi_inventory_modal_open() { this.sync_overlay_state(); },
  active_pi_inventory_ref() { this.sync_overlay_state(); },
  processing_modal_open() { this.sync_overlay_state(); },
  active_processing_ref() { this.sync_overlay_state(); },
  dsar_modal_open() { this.sync_overlay_state(); }
};

export const data_privacy_form_factories = { create_pi_inventory_form, create_processing_form, create_dsar_form };
